module.exports = __webpack_public_path__ + "static/media/check-symbol-4794.8cc185f3.svg";